export const JOB_APPLY_STATUS = {
	INTERVIEW_REQUESTED: 'interview_requested',
	INVITED_TO_INTERVIEW: 'recruiter_invited_to_interview',
	INTERVIEW_SCHEDULED: 'interview_scheduled',
	OFFER_EXTENDED: 'offer_extended',
	DOCUMENTS_NEEDED: 'document_collection',
	DOCUMENTS_IN_REVIEW_FIRST: 'petition_filed',
	DOCUMENTS_IN_REVIEW_SECOND: 'petition_approved',
	DOCUMENTS_IN_REVIEW_THIRD: 'nvc_processing',
	IMMIGRATION_PROGRESS: 'embassy_interview',
	DOCUMENTARILY_QUALIFIED: 'documentarily_qualified',
}

export const COLOR_GUIDANCE = {
	ORANGE: '#F68445',
	GREEN: '#61A60E',
	BLUE: '#2FAFEE',
}
